interface GuessDistributionProps {
  distribution: Record<string, number>;
}

export function GuessDistribution({ distribution }: GuessDistributionProps) {
  const maxCount = Math.max(...Object.values(distribution), 1);

  return (
    <div className="space-y-1" data-testid="guess-distribution">
      <h3 className="text-sm font-semibold mb-2">Guess Distribution</h3>
      {[1, 2, 3, 4, 5, 6].map((num) => {
        const count = distribution[String(num)] || 0;
        const width = Math.max((count / maxCount) * 100, 8);

        return (
          <div key={num} className="flex items-center gap-2">
            <span className="text-sm w-3 text-right">{num}</span>
            <div
              className="bg-zinc-500 text-white text-xs font-bold px-2 py-0.5 rounded-sm min-w-[24px] text-right"
              style={{ width: `${width}%` }}
            >
              {count}
            </div>
          </div>
        );
      })}
    </div>
  );
}
